const picking_mode_options = [
  { label: "Bez wózka, drobne", value: "no_cart_small" },
  { label: "Bez wózka, gabaryt", value: "no_cart_big" },
  { label: "Wózek, rozmiar 6", value: "cart_box_8" },
  { label: "Wózek, rozmiar 12", value: "cart_box_16" },
  { label: "Wózek, rozmiar 24", value: "cart_box_24" },
];

export default picking_mode_options